import { render, staticRenderFns } from "./ships.vue?vue&type=template&id=23c69b96"
import script from "./ships.vue?vue&type=script&lang=js"
export * from "./ships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports